// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.warpContent[data-v-5505970e] {\n  width: 100%;\n  background-color: #f2f2f2;\n  border-radius: 10px;\n  padding: 15px;\n  border: 1px solid #ccc;\n}\n.signImageCss[data-v-5505970e] {\n  font-size: 20px;\n  font-weight: bold;\n  color: #409eff;\n  margin: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
